import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App";
import { Home } from "./pages/Home";
import { Roster } from "./pages/Roster";
import { Login } from "./pages/Login";
import { Weekly } from "./pages/Weekly";
import { Baseline } from "./pages/Baseline";
import { MyWins } from "./pages/MyWins";
import { Attest } from "./pages/Attest";
import { Dashboard } from "./pages/Dashboard";
import { Leaderboard } from "./pages/Leaderboard";
import { PilotCandidates } from "./pages/PilotCandidates";
import { PilotCohort } from "./pages/PilotCohort";
import { Champions } from "./pages/Champions";
import { PlaybookEdits } from "./pages/PlaybookEdits";
import { Retro } from "./pages/Retro";
import { Commitments } from "./pages/Commitments";
import { DigestPreview } from "./pages/DigestPreview";
import { PrereadPreview } from "./pages/PrereadPreview";
import { Ops } from "./pages/Ops";
import "./index.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="weekly" element={<Weekly />} />
            <Route path="baseline" element={<Baseline />} />
            <Route path="wins/mine" element={<MyWins />} />
            <Route path="attest" element={<Attest />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="admin/roster" element={<Roster />} />
            <Route path="admin/pilot-candidates" element={<PilotCandidates />} />
            <Route path="admin/pilot-cohort" element={<PilotCohort />} />
            <Route path="admin/champions" element={<Champions />} />
            <Route path="admin/playbook-edits" element={<PlaybookEdits />} />
            <Route path="admin/commitments" element={<Commitments />} />
            <Route path="admin/retros/week-6/:pilot_id" element={<Retro kind="week-6" />} />
            <Route path="admin/retros/week-12/:pilot_id" element={<Retro kind="week-12" />} />
            <Route path="admin/digest-preview" element={<DigestPreview />} />
            <Route path="admin/preread/ceo-retro" element={<PrereadPreview kind="ceo-retro" />} />
            <Route path="admin/preread/champion-forum" element={<PrereadPreview kind="champion-forum" />} />
            <Route path="admin/preread/90day" element={<PrereadPreview kind="90day" />} />
            <Route path="admin/ops" element={<Ops />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
